import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Library, Settings, LogOut, BookOpen } from "lucide-react";
import { useAuthStore } from "@/store/auth";
import AdminGlobalSearch from "@/components/AdminGlobalSearch";

const nav = [
  { to: "/dashboard", icon: LayoutDashboard, label: "Dashboard", testid: "nav-dashboard" },
  { to: "/spaces", icon: Library, label: "Spaces", testid: "nav-spaces" },
  { to: "/settings", icon: Settings, label: "Organization", testid: "nav-settings" },
];

export default function AdminLayout() {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-zinc-50">
      <aside className="w-64 bg-white border-r border-zinc-200 flex flex-col sticky top-0 h-screen">
        <div className="p-6 border-b border-zinc-200">
          <Link to="/dashboard" className="flex items-center gap-2 group" data-testid="logo-link">
            <div className="w-9 h-9 bg-[#41B5E6] flex items-center justify-center rounded-sm">
              <BookOpen className="w-5 h-5 text-white" />
            </div>
            <div>
              <div className="font-bold text-[15px] tracking-tight">Handle Docs</div>
              <div className="text-[11px] text-zinc-500 uppercase tracking-wider">Admin</div>
            </div>
          </Link>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-zinc-100 text-zinc-900 border-l-2 border-[#41B5E6] -ml-[2px] pl-[14px]"
                    : "text-zinc-600 hover:bg-zinc-50 hover:text-zinc-900"
                }`
              }
            >
              <item.icon className="w-4 h-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-zinc-200">
          <div className="flex items-center gap-3 px-2 py-2">
            <div className="w-8 h-8 bg-zinc-200 rounded-full flex items-center justify-center text-xs font-bold text-zinc-700">
              {(user?.full_name || "?").charAt(0).toUpperCase()}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-[13px] font-medium truncate" data-testid="user-name">
                {user?.full_name}
              </div>
              <div className="text-[11px] text-zinc-500 truncate">{user?.email}</div>
            </div>
            <button
              onClick={async () => {
                await logout();
                navigate("/login");
              }}
              data-testid="logout-btn"
              className="text-zinc-500 hover:text-zinc-900 p-1.5 rounded-sm hover:bg-zinc-100"
              title="Logout"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </aside>

      <div className="flex-1 min-w-0 flex flex-col">
        <header className="h-14 border-b border-zinc-200 bg-white px-6 flex items-center gap-4 shrink-0">
          <AdminGlobalSearch />
        </header>
        <main className="flex-1 min-w-0 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
